// extracted by mini-css-extract-plugin
export default {"iconButton":"mobile-info-popup_iconButton__Yd8JP","popoverPaper":"mobile-info-popup_popoverPaper__ZMxaM","popoverContent":"mobile-info-popup_popoverContent__ayzrY"};